import { computed, ref } from 'vue'

import {
    widgetParameterApi,
    type CategorisedPromptTemplate,
    type PromptTemplateCategory
} from '@/api/widgetParameterApi'

const templates = ref<Array<CategorisedPromptTemplate>>([])
const categories = ref<Array<PromptTemplateCategory>>([])
const isLoading = ref(false)

let pendingRequest: Promise<void> | null = null

async function loadPromptTemplates () {
    isLoading.value = true

    try {
        const data = await widgetParameterApi.getCategoriesPromptTemplatesList()
        templates.value = data.templates
        categories.value = data.categories
    } finally {
        isLoading.value = false
        pendingRequest = null
    }
}

export function findPromptTemplateByPrompts (
    systemPrompt: string,
    userPrompt: string
): CategorisedPromptTemplate | undefined {
    if (!systemPrompt && !userPrompt) {
        return undefined
    }

    return templates.value.find(template => {
        return template.SystemPrompt === systemPrompt && template.UserPrompt === userPrompt
    })
}

export function useAiPromptTemplates () {
    function fetchPromptTemplates (force = false) {
        if (pendingRequest) {
            return pendingRequest
        }

        if (!force && templates.value.length) {
            return Promise.resolve()
        }

        pendingRequest = loadPromptTemplates()
        return pendingRequest
    }

    return {
        templates: computed(() => templates.value),
        categories: computed(() => categories.value),
        isLoading: computed(() => isLoading.value),
        fetchPromptTemplates,
        findPromptTemplateByPrompts
    }
}
